import { render, staticRenderFns } from "./widget-editor-action-buttons.vue?vue&type=template&id=6ad1ab89&"
import script from "./widget-editor-action-buttons.vue?vue&type=script&lang=js&"
export * from "./widget-editor-action-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports